import * as types from './types';

const paths = {
  [types.ROUTE_HOME]: '/',

  [types.ROUTE_EVENTS]: '/events',
  [types.ROUTE_EVENTS_SHOW]: '/events/:id',

  [types.ROUTE_SEARCH]: '/search',
  [types.ROUTE_SEARCH_QUERY_TEXT]: '/search/:queryText',

  [types.ROUTE_POLICIES]: '/policies',
  [types.ROUTE_STATIC_PLACEHOLDER]: '/static-placeholder',

  [types.ROUTE_DEMO]: '/demo',
};

export default paths;



// WEBPACK FOOTER //
// ./src/routes/paths.js